module.exports = __webpack_public_path__ + "img/teatcher.33a69fc8.png";